import { generateChildrenFromList } from "cms/parsers";

const SponsorBlock = props => {
    const sponsorGroups = generateChildrenFromList(props.paragraph.relationships.field_sponsor_groups.data);
    
    return (
        <>
            {sponsorGroups}
        </>
    );
};

export default SponsorBlock;
